import React, {useEffect, useRef, useState} from 'react'
import GeneCoverageChart from './GeneCoverageChart'
import RangeSlider from '../../RangeSlider/RangeSlider'
import {Tooltip} from 'react-tooltip'
const metricDisplayNames = {
  meanDepth: 'Mean Depth',
  minDepth: 'Minimum Depth',
  maxDepth: 'Maximum Depth',
  percentCovered100x: 'Percent at 100x',
}

const GeneCoverageHeathMap = ({
  groupedData,
  baseCoverageData,
  fetchCoverageData,
  node,
  sampleId,
  coverageData,
  fetchCoverageDataByGene,
  runId,
  setMaxDepthThreshold,
  maxDepthThreshold,
  metric,
  sort,
  sortDirection,
  searchTerm,
  minRange,
  maxRange,
  minRangeValue,
  maxRangeValue,
  filterByRegions,
  showListedOnly,
  filteredGenes,
  baseFilteredGenes,
  setFilteredGenes,
  setBaseFilteredGenes,
  setShowListedOnly,
  setFilterByRegions,
  setMaxRange,
  setMinRange,
  setMinRangeValue,
  setMaxRangeValue,
  setMetric,
  setSort,
  setSortDirection,
  setSearchTerm,
  setMaxDepthThresholdPrev,
  maxDepthThresholdPrev,
  filterMetric,
  setFilterMetric,
  setCoverageData,
}) => {
  const [isFetching, setIsFetching] = useState(false)
  const [expandedGene, setExpandedGene] = useState(null)
  const [chartData, setChartData] = useState(null)
  const chartRef = useRef()
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(21)
  const [showFilterMenu, setShowFilterMenu] = useState(false)

  useEffect(() => {
    if (coverageData?.genes) {
      const initialFiltered = coverageData.genes
        .filter((gene) => gene.name.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => {
          if (sort === 'name') {
            if (sortDirection === 'asc') {
              return a.name.localeCompare(b.name)
            } else if (sortDirection === 'desc') {
              return b.name.localeCompare(a.name)
            }
          } else {
            if (sortDirection === 'asc') {
              return a[sort] - b[sort]
            } else if (sortDirection === 'desc') {
              return b[sort] - a[sort]
            } else {
              return b[sort] - a[sort]
            }
          }
        })

      // Calculate initial range values
      if (initialFiltered.length > 0) {
        const values = initialFiltered.map((gene) => gene[filterMetric])
        const min = Math.min(...values)
        const max = Math.max(...values)
        setMinRange(Math.floor(min))
        setMaxRange(Math.ceil(max))
      }

      setBaseFilteredGenes(initialFiltered)
      setFilteredGenes(initialFiltered)
    }
  }, [coverageData, searchTerm])

  useEffect(() => {
    if (baseFilteredGenes.length > 0) {
      let filtered = [...baseFilteredGenes]
      // Apply range filter
      filtered = filtered.filter((gene) => {
        const value = gene[filterMetric]
        return value >= minRangeValue && value <= maxRangeValue
      })

      if (showListedOnly) {
        filtered = filtered.filter((gene) => gene.isListed)
      }

      filtered.sort((a, b) => {
        if (sort === 'name') {
          if (sortDirection === 'asc') {
            return a.name.localeCompare(b.name)
          } else if (sortDirection === 'desc') {
            return b.name.localeCompare(a.name)
          }
        } else {
          if (sortDirection === 'asc') {
            return a[sort] - b[sort]
          } else if (sortDirection === 'desc') {
            return b[sort] - a[sort]
          } else {
            return b[sort] - a[sort]
          }
        }
      })

      // setFilteredGenes(filtered)
    }
  }, [
    baseFilteredGenes,
    filterMetric,
    minRange,
    maxRange,
    minRangeValue,
    maxRangeValue,
    filterByRegions,
    showListedOnly,
    sort,
    sortDirection,
  ])
  // Update range values when filterMetric changes
  const applyFilters = async () => {
    if (baseFilteredGenes.length > 0) {
      let filtered = []
      if (filterByRegions) {
        filtered = await fetchCoverageData(node, sampleId,  maxDepthThresholdPrev)
        filtered = filtered.genes
      } else {
        setMaxDepthThreshold(0)
        filtered = [...(baseCoverageData?.genes || [])]
      }
      // if byregion baseFilteredGenes else baseCoverageData
      // let filtered = filterByRegions ? [...baseFilteredGenes] : [...(baseCoverageData?.genes || [])]
      filtered = filtered.filter((gene) => {
        const value = gene[filterMetric]
        return value >= minRangeValue && value <= maxRangeValue
      })
      filtered.sort((a, b) => {
        if (sort === 'name') {
          if (sortDirection === 'asc') {
            return a.name.localeCompare(b.name)
          } else if (sortDirection === 'desc') {
            return b.name.localeCompare(a.name)
          }
        } else {
          if (sortDirection === 'asc') {
            return a[sort] - b[sort]
          } else if (sortDirection === 'desc') {
            return b[sort] - a[sort]
          } else {
            return b[sort] - a[sort]
          }
        }
      })
      if (showListedOnly) {
        filtered = filtered.filter((gene) => groupedData[gene.name])
      }
    

      setFilteredGenes(filtered)
      setCurrentPage(1)
    }
  }
  // const createBaseFilters = () => {
  //   if (baseCoverageData?.genes.length > 0) {
  //     const values = baseCoverageData?.genes.map((gene) => gene[filterMetric])
  //     const min = Math.min(...values)
  //     const max = Math.max(...values)

  //     setMinRange(Math.floor(min))
  //     setMaxRange(Math.ceil(max))
  //   }
  // }

  useEffect(() => {
    // just apply sort and direction to filteredGenes
    if (filteredGenes.length > 0) {
      let filtered = [...filteredGenes]
      filtered.sort((a, b) => {
        if (sort === 'name') {
          if (sortDirection === 'asc') {
            return a.name.localeCompare(b.name)
          } else if (sortDirection === 'desc') {
            return b.name.localeCompare(a.name)
          }
        } else {
          if (sortDirection === 'asc') {
            return a[sort] - b[sort]
          } else if (sortDirection === 'desc') {
            return b[sort] - a[sort]
          } else {
            return b[sort] - a[sort]
          }
        }
      })
      setFilteredGenes(filtered)
    }
  }, [sort, sortDirection])

  function getColor(value, metric) {
    const maxValue =
      metric === 'percentCovered100x' ? 100 : Math.max(...coverageData?.genes.map((g) => g[metric]))
    const intensity = Math.min(value / maxValue, 1)
    if (intensity < 0.1) return '#f0f9ff'
    if (intensity < 0.3) return '#bae6fd'
    if (intensity < 0.5) return '#7dd3fc'
    if (intensity < 0.7) return '#38bdf8'
    if (intensity < 0.9) return '#0ea5e9'
    return '#0369a1'
  }
  function getTextColor(value, metric) {
    const maxValue =
      metric === 'percentCovered100x' ? 100 : Math.max(...coverageData?.genes.map((g) => g[metric]))
    const intensity = Math.min(value / maxValue, 1)
    return intensity < 0.3 ? '#000' : '#fff'
  }

  function formatValue(value, metric) {
    return metric === 'percentCovered100x' ? `${value.toFixed(1)}%` : `${Math.round(value)}x`
  }

  const startIndex = (currentPage - 1) * itemsPerPage
  const paginatedGenes = filteredGenes.slice(startIndex, startIndex + itemsPerPage)

  const groupedGenes = []
  for (let i = 0; i < paginatedGenes.length; i += 3) {
    groupedGenes.push(paginatedGenes.slice(i, i + 3))
  }

  const totalPages = Math.ceil(filteredGenes.length / itemsPerPage)

  const handleExpand = async (gene) => {
    if (expandedGene === gene.name) {
      setExpandedGene(null)
    } else {
      setIsFetching(true)
      setExpandedGene(gene.name)
      const coverageDataByGene = await fetchCoverageDataByGene(gene.name)
      // add color to coverageDataByGene.regions
      coverageDataByGene.regions.forEach((region) => {
        region.color = getColor(region.depth, filterMetric)
      })
      console.log(coverageDataByGene)
      if (coverageDataByGene) {
        setChartData(coverageDataByGene)
      }
      setIsFetching(false)
    }
  }
  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm, sort, metric])
  useEffect(() => {
    const calculateItemsPerPage = () => {
      const windowHeight = window.innerHeight
      const offsetAboveList = 0 // filtreler + header tahmini yüksekliği (ayarlayabilirsin)
      const cardHeight = 50 // bir hücrenin ortalama yüksekliği

      const usableHeight = windowHeight - offsetAboveList
      const items = Math.floor(usableHeight / cardHeight)

      // 3'ün katı yap (her satırda 3 hücre olduğu için)
      setItemsPerPage(Math.max(3, Math.floor(items / 3) * 3))
    }

    calculateItemsPerPage()
    window.addEventListener('resize', calculateItemsPerPage)

    return () => window.removeEventListener('resize', calculateItemsPerPage)
  }, [])

  const handleClearFilters = () => {
    const sortedBaseCoverageData = baseCoverageData?.genes?.sort((a, b) => {
      if (sort === 'name') {
        if (sortDirection === 'asc') {
          return a.name.localeCompare(b.name)
        } else if (sortDirection === 'desc') {
          return b.name.localeCompare(a.name)
        }
      } else {
        if (sortDirection === 'asc') {
          return a[sort] - b[sort]
        } else if (sortDirection === 'desc') {
          return b[sort] - a[sort]
        } else {
          return b[sort] - a[sort]
        }
      }
    })
    const values = sortedBaseCoverageData.map((gene) => gene[filterMetric])
    const min = Math.min(...values)
    const max = Math.max(...values)

    setFilteredGenes(sortedBaseCoverageData)
    setCoverageData(baseCoverageData)
    setBaseFilteredGenes(sortedBaseCoverageData)
    setMaxDepthThreshold(0)
    setMaxDepthThresholdPrev(0)
    setFilterByRegions(false)
    setMinRangeValue(Math.floor(min))
    setMaxRangeValue(Math.ceil(max))
  }

  const handleApplyFilters = () => {
    applyFilters()
    setShowFilterMenu(false)
  }
  useEffect(() => {
      if (!filterByRegions) {
        const values = baseCoverageData?.genes.map((gene) => gene[filterMetric])
        const min = Math.min(...values)
        const max = Math.max(...values)
        setMinRange(Math.floor(min))
        setMaxRange(Math.ceil(max))
        setMinRangeValue(Math.floor(min))
        setMaxRangeValue(Math.ceil(max))
      }
  }, [filterByRegions])

  return (
    <div className=' py-4 pt-0'>
      <div className='row mb-4'>
        <div className='col-12'>
          <div
            style={{
              height: 'auto',
            }}
          >
            <div
              className='card-header py-3 pb-0 d-flex justify-content-between align-items-center'
              style={{
                minHeight: 'auto',
              }}
            >
              <h5 className='mb-0'>Gene Heatmap</h5>
              <div className='position-relative'>
                <button
                  className='btn btn-white btn-bordered d-flex align-items-center gap-2'
                  onClick={() => setShowFilterMenu(!showFilterMenu)}
                >
                  <i className='fa fa-filter'></i>
                  <span>Filter</span>
                  <i className={`fas fa-chevron-${showFilterMenu ? 'up' : 'down'}`}></i>
                </button>

                {showFilterMenu && (
                  <div
                    className='position-absolute end-0 mt-2 bg-white border rounded shadow-lg p-3'
                    style={{width: '300px', zIndex: 0}}
                  >
                    <div className='mb-3'>
                      <select
                        className='form-select'
                        value={filterMetric}
                        onChange={(e) => setFilterMetric(e.target.value)}
                      >
                        <option value='meanDepth'>Mean Depth</option>
                        <option value='minDepth'>Min Depth</option>
                        <option value='maxDepth'>Max Depth</option>
                      </select>
                    </div>

                    <div className='mb-3 '>
                      {/* <div className='d-flex gap-2'>
                        <input
                          type='number'
                          className='form-control'
                          placeholder='Min'
                          value={minRange}
                          onChange={(e) => setMinRange(e.target.value)}
                        />
                        <input
                          type='number'
                          className='form-control'
                          placeholder='Max'
                          value={maxRange}
                          onChange={(e) => setMaxRange(e.target.value)}
                        />
                      </div> */}
                      <RangeSlider
                        min={minRange}
                        max={maxRange}
                        minRangeValue={minRangeValue}
                        maxRangeValue={maxRangeValue}
                        setMinRangeValue={setMinRangeValue}
                        setMaxRangeValue={setMaxRangeValue}
                      />
                    </div>

                    <div className='mb-3'>
                      <div className='form-check mb-3'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          id='filterByRegions'
                          checked={filterByRegions}
                          onChange={(e) => setFilterByRegions(e.target.checked)}
                        />
                        <label className='form-check-label' htmlFor='filterByRegions'>
                          Filter By Regions
                          <i
                            className='fas fa-info-circle ms-1'
                            data-tooltip-id='my-tooltip'
                            data-tooltip-place='left'
                            data-tooltip-html='
                            <center>
                             Filter by individual genomic regions within genes instead of entire genes. <br> When enabled, you can find genes that contain<br> regions with coverage below the specified threshold.
                            </center>
                          '
                          ></i>
                        </label>
                      </div>
                      {filterByRegions && (
                        <div className='mb-3'>
                          <label className='form-label'>Max Depth Threshold</label>
                          <input
                            type='number'
                            className='form-control'
                            placeholder='e.g., 100'
                            value={maxDepthThresholdPrev}
                            onChange={(e) => setMaxDepthThresholdPrev(e.target.value)}
                          />
                          <small className='text-muted'>Show genes with regions ≤ this depth</small>
                        </div>
                      )}
                      <div className='form-check'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          id='showListedOnly'
                          checked={showListedOnly}
                          onChange={(e) => setShowListedOnly(e.target.checked)}
                        />
                        <label className='form-check-label' htmlFor='showListedOnly'>
                          Show Listed Only
                        </label>
                      </div>
                    </div>

                    <div className='d-flex justify-content-between gap-2'>
                      <button
                        className='btn btn-outline-secondary flex-grow-1'
                        onClick={handleClearFilters}
                      >
                        Clear Filters
                      </button>
                      <button className='btn btn-primary flex-grow-1' onClick={handleApplyFilters}>
                        Apply Filters
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='d-flex gap-5 mb-2 mt-4 px-4 align-items-center'>
              <div>
                <button
                  className='btn btn-white border d-flex align-items-center gap-2'
                  onClick={() =>
                    setSortDirection(
                      sortDirection === 'default' ? 'asc' : sortDirection === 'asc' ? 'desc' : 'asc'
                    )
                  }
                >
                  <i
                    className={`fa fa-sort p-0 ${
                      sortDirection === 'asc'
                        ? 'fa-sort-up'
                        : sortDirection === 'desc'
                        ? 'fa-sort-down'
                        : ''
                    }`}
                  ></i>
                </button>
              </div>
              <div className='w-25'>
                <select
                  className='form-select'
                  value={sort}
                  onChange={(e) => setSort(e.target.value)}
                >
                  <option value='meanDepth'>Mean Depth</option>
                  <option value='minDepth'>Minimum Depth</option>
                  <option value='maxDepth'>Maximum Depth</option>
                  <option value='name'>Gene Name </option>
                </select>
              </div>
              <div className='w-100'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Type Gene Name'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className='text-end pull-right px-4 my-2 w-100'>
              <span className='text-muted'>
                Showing {filteredGenes.length} genes
                {minRange !== 0 || maxRange !== 10000
                  ? ` (Filtered by ${metricDisplayNames[filterMetric]})`
                  : ''}
              </span>
            </div>
            <div
              className='card-body pt-2 pb-3 px-4'
              style={{
                height: 'auto',
              }}
            >
              {groupedGenes.map((group, i) => (
                <React.Fragment key={i}>
                  <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 mb-1'>
                    {group.map((gene) => (
                      <div
                        key={gene.name}
                        className='border rounded-lg rounded p-2 '
                        style={{
                          backgroundColor: getColor(gene[metric], metric),
                          cursor: 'pointer',
                          color: getTextColor(gene[metric], metric),
                        }}
                        onClick={() => {
                          handleExpand(gene)
                        }}
                      >
                        <div className='d-flex justify-content-between align-items-center mb-2'>
                          <div
                            className='fw-bold text-lg '
                            style={{padding: '10px', borderRadius: '5px'}}
                          >
                            {gene.name}
                            <br />
                            <span className='fw-normal fs-8'>
                              Mean: {gene.meanDepth}x <br />
                              Min: {gene.minDepth}x | Max: {gene.maxDepth}x
                            </span>
                          </div>
                          <span className='badge bg-light text-dark'>
                            {formatValue(gene[metric], metric)}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                  {group.some((g) => g.name === expandedGene) && (
                    <div className='row mb-4'>
                      <div className='col-12'>
                        <div className='bg-white p-4 border rounded'>
                          <div
                            onMouseMove={(e) => {
                              const points = chartRef.current?.getElementsAtEventForMode(
                                e.nativeEvent,
                                'nearest',
                                {intersect: true},
                                true
                              )
                              e.target.style.cursor = points?.length ? 'pointer' : 'default'
                            }}
                          >
                            {isFetching ? (
                              <div className={` h-auto text-center  py-2 `}>
                                <div
                                  className='spinner-grow text-primary m-auto py-2'
                                  role='status'
                                >
                                  <span className='visually-hidden'>Loading...</span>
                                </div>
                              </div>
                            ) : (
                              <GeneCoverageChart ref={chartRef} data={chartData} runId={runId} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
              <div className='d-flex justify-content-center align-items-center mt-4'>
                <nav>
                  <ul className='pagination flex-wrap'>
                    {/* First */}
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className='page-link' onClick={() => setCurrentPage(1)}>
                        ‹‹{' '}
                      </button>
                    </li>

                    {/* Previous */}
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button
                        className='page-link'
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                      >
                        ‹{' '}
                      </button>
                    </li>

                    {/* Dynamic Page Numbers */}
                    {(() => {
                      const maxVisiblePages = 5
                      let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2))
                      let endPage = startPage + maxVisiblePages - 1

                      if (endPage > totalPages) {
                        endPage = totalPages
                        startPage = Math.max(1, endPage - maxVisiblePages + 1)
                      }

                      const pages = []
                      for (let i = startPage; i <= endPage; i++) {
                        pages.push(
                          <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                            <button className='page-link' onClick={() => setCurrentPage(i)}>
                              {i}
                            </button>
                          </li>
                        )
                      }
                      return pages
                    })()}

                    {/* Next */}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button
                        className='page-link'
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                      >
                        {' '}
                        ›
                      </button>
                    </li>

                    {/* Last */}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className='page-link' onClick={() => setCurrentPage(totalPages)}>
                        ››{' '}
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Tooltip id='my-tooltip' />
    </div>
  )
}

export default GeneCoverageHeathMap
